import React from "react";
import {Pane} from "evergreen-ui";
import {useSelector} from "react-redux";

export default function RiverFloodSnowTable() {

    const tableStyle = {
        tableLayout: "fixed",
        width: "1600px",
        borderCollapse: "collapse",
        marginBottom: "90px",
        fontFamily: "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
    }

    const constructor = useSelector(state => state.riverFloodConstructor);
    const filtersRows = constructor.filters;

    const createTable = () => {

        return (
            <table border={"1px"} style={tableStyle}>
                <tr>
                    <th width={250} rowSpan={2}>Наименование источника</th>
                    <th colSpan={3}>Дата</th>
                    <th colSpan={4}>Характеристика снежного покрова на дату измерения максимума снегозапасов</th>
                </tr>
                <tr>
                    <th>начала снегонакопления</th>
                    <th>измерения максимума снегозапасов</th>
                    <th>начала водоотдачи из снега</th>
                    <th>высота, см</th>
                    <th>плотность, г/см³</th>
                    <th>запас воды в снеге, мм</th>
                    <th>запас воды в ледяной корке, мм</th>
                </tr>

                {filtersRows.map(filter =>
                    <tr>
                        <td width={250} height={20}>{filter.rainfall.type.name}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )}

            </table>
        );
    }

    return (
        <>
            <Pane marginTop={30}><h3>Характеристика снежного покрова на водосборах</h3></Pane>
            <Pane marginTop={30} width={1600}>
                {createTable()}
            </Pane>
        </>
    )
}